import React from 'react';
import * as S from './styled';
export const SideSummaryItem = ({ title, children }) => {
    return (React.createElement(S.Container, null,
        title && React.createElement(S.Title, null, title),
        children && React.createElement(S.Children, null, children)));
};
